import React, { Fragment } from "react";

const BlackLogo = () => {
  return (
    <Fragment>
      <svg viewBox="0 0 463.98 463.98" style={{ fill: "#000000" }}>
        <g>
          <path
            class="st0"
            d="M188.2,231.3c0.6,0.4,1.1,0.7,1.5,1c0.4,0.4,0.8,0.7,1.3,1c0,0.7-0.1,1.1-0.2,1.3c-7.9,11.4-15.2,22-22,31.7
		s-14.1,19-22,27.8c-1.4,1.6-2.8,2.5-4.3,2.9c-1.5,0.3-2.9,0.3-4.4,0c-1.5-0.3-2.9-0.9-4.3-1.7s-2.8-1.6-4.2-2.5
		c-4.2-1.7-6.7-5.3-7.6-10.6c-1.2-11.8-0.1-22.6,3.5-32.4c3.5-9.9,8.2-18.9,14.1-27c3.1-2.6,5.6-3.1,7.5-1.6
		c1.9,1.6,3.7,3.6,5.4,6.2c-3.4,5.7-6,10.7-7.8,14.9c-1.8,4.2-3.1,8.4-3.9,12.6c-0.9,4.1-1.4,8.7-1.6,13.8c-0.2,5-0.4,11.2-0.6,18.4
		c4.8-3.8,9.4-8.1,13.8-12.9c4.4-4.8,8.7-9.6,12.8-14.5c4.2-4.9,8.1-9.9,11.9-14.8C181,240,184.7,235.4,188.2,231.3z M169.9,190.8
		c-1.9,2.6-3.6,4.8-5.1,6.6c-1.5,1.8-3.1,3.6-4.5,5.2c-1.5,1.6-3,3.4-4.5,5.2c-1.5,1.8-3.2,3.9-5.1,6.4c-1.5-0.7-2.5-1.6-2.8-2.7
		c-0.3-1.1-1-2.3-2.1-3.5c-1.1-1.6-1.4-3.5-0.9-5.8c0.5-2.3,1.3-4.7,2.4-7c1.2-2.3,2.5-4.5,4.1-6.5c1.5-2,2.9-3.4,4.2-4.3
		c1.7-0.9,3.2-1.2,4.6-1.2c1.4,0.1,2.7,0.5,3.8,1.3s2.2,1.7,3.1,2.9C168.1,188.4,169,189.6,169.9,190.8z"
          />
          <path
            class="st0"
            d="M277.1,214.4c1.2,1,2.5,2,3.7,2.9c1.2,0.9,2.4,1.8,3.5,2.9c0.5,0.4,0.9,0.9,1.3,1.7c0.4,0.8,0.5,1.6,0.4,2.5
		c0,2.1-0.4,4.2-1.2,6.5c-1.5,4.7-3,9.4-4.4,14c-1.4,4.7-2.9,9.4-4.4,14c-1.9,6.1-3.7,12.7-5.7,20c-1.9,7.3-3.5,14.6-4.7,21.9
		c-1.2,7.4-2,14.6-2.2,21.8s-5.9,34.8-4.5,40.8c1.4-0.9,24.7-42.2,26.8-45.8c2.2-3.5,3.7-6.7,4.6-9.5c1.1,0.3,2.1,0.7,3.1,1.2
		c1,0.4,2.1,0.9,3.4,1.4c-0.9,2.6-2.4,5.6-4.3,9c-1.9,3.4-23.3,47.8-24.9,50.4c-2.2,3.6-4.9,4.8-8.3,3.6c-1.2-0.5-2.5-0.9-3.9-1.2
		c-1.4-0.3-2.7-0.6-3.9-0.9c-3.6-0.9-5.8-3.1-6.7-6.8c-3.4-13.1,1.7-46.8,2.9-58.9c1.2-12.1,3.4-23.8,6.6-35
		c1.4-4.5,2.8-9.1,4.2-13.8c1.4-4.7,2.9-9.5,4.4-14.5c-0.6,0.5-1.1,1-1.5,1.3c-0.4,0.4-0.7,0.8-1,1.3L238,279.6
		c-2.2,3.5-4.2,6.9-6.2,10.2c-2,3.4-4,6.8-6,10.3c-1.5,2.4-3.3,3.3-5.3,2.6c-1.1-0.4-2.1-0.6-3-0.8c-0.9-0.2-1.9-0.4-3-0.8
		c-2-0.5-3.4-1.4-4.2-2.6s-1-3-0.7-5.5c0.3-2.4,0.6-4.8,0.9-7.1c0.3-2.3,0.7-4.6,1.2-6.9c1.2-6.1,2.5-12,3.9-17.8
		c1.4-5.8,2.7-11.7,3.9-17.8v-1.8l-3,3.4c-4.5,6.1-8.7,12.4-12.6,19c-3.9,6.6-7.8,13.1-11.4,19.7c-1.1,1.9-2.2,3.7-3.2,5.3
		c-1.1,1.6-2.2,3.3-3.2,5.1c-1.4,2.4-3.3,3.3-5.8,2.6c-1.5-0.3-3-0.6-4.4-0.9s-2.9-0.6-4.4-0.9c-2-0.5-3-1.9-3-4.1
		c0-1.7,0-3.5,0.1-5.2s0.3-3.5,0.6-5.2c2.2-10.9,5-21.3,8.4-31.3c3.5-9.9,7.9-19.6,13.3-28.9c0.8-1.4,1.6-2.7,2.5-3.9
		c0.9-1.2,1.9-2.5,2.8-3.9c0.9,0,1.5,0.1,1.6,0.3c2.9,1.7,4.7,3.1,5.2,4.1c0.5,1,0.4,3.3-0.6,6.8c-1.5,6.1-3.1,11.9-4.6,17.6
		c-1.5,5.7-3.2,11.5-4.9,17.4c-0.3,0.9-0.5,1.8-0.7,2.7c-0.2,1-0.2,2,0,3c0.3-0.7,0.7-1.3,1.2-2c0.5-0.6,0.9-1.2,1.2-2
		c4.8-7.8,9.8-15.2,15.1-22.3s11.1-13.8,17.5-20c2-2.1,3.4-3.1,4.2-3.1s2.2,0.8,4.4,2.3c1.5,1,2.7,2,3.6,2.9
		c0.9,0.9,1.4,1.7,1.7,2.6c0.3,0.9,0.4,1.9,0.4,3.1c-0.1,1.2-0.4,2.9-0.8,4.9c-1.2,5.9-2.5,11.7-3.9,17.4s-2.7,11.5-3.9,17.4
		c-0.3,0.9-0.5,1.7-0.6,2.6s0,1.9,0.4,3.1c0.8-1.4,1.5-2.6,2.2-3.8c0.7-1.1,1.4-2.4,2.2-3.8c5.7-10.6,12.4-20.4,20.1-29.6
		c3.1-3.6,6.2-7.1,9.5-10.4C269.7,220.5,273.2,217.4,277.1,214.4z"
          />
          <path
            class="st0"
            d="M305.5,257.8c-0.5,4.7-0.7,9.1-0.6,13.2c0.1,4.1,0.8,8.2,2.2,12.2c0.8,2.4,1.5,3.9,2.1,4.3
		c0.6,0.4,2,0.5,4.2,0.1c3.9-0.3,7.1-1.7,9.7-4.1c3.5-3.6,7.1-7.2,10.8-10.8c3.6-3.5,7.2-7.1,10.8-10.8c4-4,7.9-8.1,11.7-12.3
		c3.8-4.2,7.6-8.4,11.5-12.6c0.9-1,1.9-1.6,2.9-1.7c1-0.1,2.2,0.1,3.6,0.6c-0.5,0.9-0.9,1.6-1.3,2.3c-0.4,0.7-0.8,1.4-1.3,2.1
		c-5.4,6.9-10.7,13.8-15.9,20.6c-5.2,6.8-10.5,13.6-15.9,20.4c-1.7,2.1-3.5,4-5.3,5.8s-3.8,3.6-5.8,5.3c-2.8,2.4-5.7,3.9-8.7,4.4
		c-3,0.5-6.1-0.3-9.4-2.6c-2.2-1.6-4.4-3.1-6.6-4.7c-2.2-1.6-4.4-3-6.6-4.4c-3.1-2.2-5.3-4.9-6.7-7.9c-1.4-3-2.2-6.4-2.5-10.2
		c-2.3-24.1,5-43,22-56.9c0.8-0.7,1.6-1.3,2.5-1.9c0.9-0.6,1.8-1.3,2.5-1.9c2-1.9,4.2-3.1,6.5-3.6c2.3-0.5,4.8-0.6,7.4-0.3
		c0.8,0,1.6,0.2,2.4,0.6c0.9,0.4,1.5,1,2,1.7c1.9,2.6,3.7,5.2,5.5,7.8c1.9,2.6,3.5,5.4,5.1,8.3c1.5,3.1,2.3,6.3,2.2,9.6
		c-0.1,3.3-0.7,6.6-2,9.9c-1.7,4.9-4.1,8.9-7.3,12.3s-6.8,6.2-10.8,8.4c-3.1,1.7-6.2,2.5-9.2,2.3c-3.1-0.2-6.1-1.5-9-3.9
		c-0.3-0.3-0.7-0.6-1-0.8C306.9,258.6,306.3,258.3,305.5,257.8z M306.7,253.4c7.7,0.7,14.1-1.6,19.2-7c2.8-2.9,5-6.1,6.8-9.6
		c1.8-3.5,3.3-7.2,4.5-11.2c0.3-1,0.5-2.2,0.7-3.4c0.1-1.2,0.3-2.5,0.5-3.9c0.1-1-0.1-1.8-0.7-2.3c-0.6-0.5-1.4-0.7-2.3-0.5
		c-0.6,0-1.5,0.2-2.8,0.5c-3.1,0.7-5.7,2.1-7.9,4.1c-2.2,2.1-4.2,4.3-6.2,6.8c-3.1,3.5-5.5,7.4-7.3,11.9
		C309.4,243.3,307.9,248.2,306.7,253.4z"
          />
        </g>
        <path
          class="st0"
          d="M242.8,92.8c-82.6,0-149.5,66.9-149.5,149.5c0,82.5,66.8,149.4,149.3,149.5c-0.3-3.1-0.6-6.2-0.6-9.4
	c-76.9-0.4-139.4-63.1-139.4-140.1c0-77.3,62.9-140.1,140.1-140.1S382.9,165,382.9,242.3c0,62.9-41.7,116.2-98.9,133.9
	c0.7,3,1.5,6.1,2.4,9.1c61.3-18.7,105.9-75.6,105.9-143C392.3,159.7,325.4,92.8,242.8,92.8z"
        />
        <g>
          <path
            class="st0"
            d="M354.9,114.6l-8.5,9.3c32,28.8,52.1,70.5,52.1,116.8c0,86.7-70.6,157.3-157.3,157.3
		C154.5,398,84,327.5,84,240.7c0-46.3,20.1-88,52.1-116.8l-8.5-9.3c-0.4,0.4-10.3,10.2-10.7,10.7c-28.1,30.3-45.4,70.8-45.4,115.5
		c0,93.7,76,169.7,169.7,169.7S411,334.5,411,240.7c0-44.4-17.1-84.8-45-115.1C365.4,125.1,355.5,115.2,354.9,114.6z"
          />
        </g>
      </svg>
    </Fragment>
  );
};

export default BlackLogo;
